module.exports = __webpack_public_path__ + "static/fipcwhitesheephamper-63a991d0509936bd658bbd1532f75972.jpeg";